import script from "./ReverseCheckModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReverseCheckModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__